// extracted by mini-css-extract-plugin
export default {"checkout_summary":"MG","checkout_summary_wrapper":"NG","summary_items":"OG","line_items_wrapper":"PG","separator":"QG","order_summary":"RG","line_item":"SG","order__summary_item_title":"TG","recurringdis":"UG","note":"VG","carbon_emission":"WG","unlock_savings":"XG","member_perk":"YG","info":"ZG","no_items":"aH","promo":"bH","order_summary_mobile":"cH","open_summary_mobile":"eH","fixed_bottom_info":"fH","open_info":"gH","text":"hH","open_summary":"iH"};
    if(module.hot) {
      // 1738836196968
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  